import { Field } from 'react-final-form';
import Radio from 'components/other/Radio';
import Icon from 'components/other/Icons';

import styles from './TestForm.module.scss';

const UnlistedTradesKnowledgeField = field => (
  <div className={styles.FieldContainer} tabIndex="0">
    <p>
      Kunnskap om <b>unoterte</b> instrumenter:
    </p>
    <Field name="unlistedTradesKnowledge" type="radio" value="low">
      {({ input }) => (
        <label htmlFor="unlistedTradesKnowledge_low">
          <Radio
            id="unlistedTradesKnowledge_low"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Ingen
        </label>
      )}
    </Field>
    <Field name="unlistedTradesKnowledge" type="radio" value="medium">
      {({ input }) => (
        <label htmlFor="unlistedTradesKnowledge_medium">
          <Radio
            id="unlistedTradesKnowledge_medium"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Middels
        </label>
      )}
    </Field>
    <Field name="unlistedTradesKnowledge" type="radio" value="high">
      {({ input }) => (
        <label htmlFor="unlistedTradesKnowledge_high">
          <Radio
            id="unlistedTradesKnowledge_high"
            type="radio"
            value={input.value}
            checked={input.checked}
            onChange={input.onChange}
          />
          Høy
        </label>
      )}
    </Field>
    {field.meta.error && field.meta.touched && (
      <div className={styles.errorContainer}>
        <Icon icon="exclamation-triangle" />
        <span>{field.meta.error}</span>
      </div>
    )}
  </div>
);

export default UnlistedTradesKnowledgeField;
